// extracted by mini-css-extract-plugin
export var box = "Modal-module--box--e15d4";
export var fadeIn = "Modal-module--fadeIn--d64b1";
export var overlay = "Modal-module--overlay--a8e66";
export var slideUp = "Modal-module--slideUp--a80ad";